<template>
  <tr>
    <template v-if="$vuetify.display.mdAndUp">
      <td style="position: relative">
        {{ $dayjs.date(item.vaccinationDate) }}
      </td>
      <td class="text-center">
        <div
          v-if="item"
          :class="
            icon({
              returnType: 'color',
              stageType: 'calculatedCourseStage',
              rule: 'national'
            })
          "
        >
          <b style="font-size: x-large">
            {{
              icon({
                returnType: "icon",
                stageType: "calculatedCourseStage",
                rule: "national"
              })
            }}
          </b>
        </div>
      </td>
      <td>
        <v-tooltip v-if="item.calculatedCourseStage" location="bottom">
          <template #activator="{ props }">
            <div v-bind="props">
              {{ $t("horses:vaccination.stage." + item.calculatedCourseStage) }}
              <br />
              ({{
                vaccinationAllowsToCompetePeriodText(
                  "allowsToCompeteNationallyUntil"
                )
              }})
            </div>
          </template>
          <span>
            {{
              $t(
                "horses:vaccinations.ExplanatoryTextforStageCalculation.text",
                "Automatically calculated based on the preceeding vaccination date. Note that calculations will be corrected after all vaccinations entered"
              )
            }}
          </span>
        </v-tooltip>
        <v-tooltip
          v-if="
            item.courseStage &&
            item.calculatedCourseStage != item.courseStage &&
            item.isOfficial
          "
          location="bottom"
        >
          <template #activator="{ props }">
            <div v-bind="props">
              {{ $t("horses:vaccination.stage." + item.courseStage) }}
              {{
                $t("horses:vaccinations.HeppaSourceReference.label", "(HEPPA)")
              }}
            </div>
          </template>
          <span>
            {{
              $t(
                "horses:vaccinations.TooltipHeppaData.label",
                "Data submitted by veterinarian to Hippos register"
              )
            }}
          </span>
        </v-tooltip>
      </td>
      <td class="text-center">
        <div
          v-if="item"
          :class="
            icon({
              returnType: 'color',
              stageType: 'calculatedCourseStageFei',
              rule: 'international'
            })
          "
        >
          <b style="font-size: x-large">
            {{
              icon({
                returnType: "icon",
                stageType: "calculatedCourseStageFei",
                rule: "international"
              })
            }}
          </b>
        </div>
      </td>
      <td>
        <v-tooltip v-if="item.calculatedCourseStageFei" location="bottom">
          <template #activator="{ props }">
            <div v-bind="props">
              {{
                $t("horses:vaccination.stage." + item.calculatedCourseStageFei)
              }}
              <br />
              ({{
                vaccinationAllowsToCompetePeriodText(
                  "allowsToCompeteInternationallyUntil"
                )
              }})
            </div>
          </template>
          <span>
            {{
              $t(
                "horses:vaccinations.ExplanatoryTextforStageCalculation.text",
                "Automatically calculated based on the preceeding vaccination date. Note that calculations will be corrected after all vaccinations entered"
              )
            }}
          </span>
        </v-tooltip>
        <v-tooltip
          v-if="
            item.courseStage &&
            item.calculatedCourseStageFei != item.courseStage &&
            item.isOfficial
          "
          location="bottom"
        >
          <template #activator="{ props }">
            <div v-bind="props">
              {{ $t("horses:vaccination.stage." + item.courseStage) }}
              {{
                $t("horses:vaccinations.HeppaSourceReference.label", "(HEPPA)")
              }}
            </div>
          </template>
          <span>
            {{
              $t(
                "horses:vaccinations.TooltipHeppaData.label",
                "Data submitted by veterinarian to Hippos register"
              )
            }}
          </span>
        </v-tooltip>
      </td>
      <td>{{ item.comment }}</td>
      <td>{{ item.veterinarianName }}</td>
      <td>
        <template v-if="item.isOfficial">
          {{ $t("horses:vaccinations.sourceOfficial", "Official") }}
        </template>
        <AppShowPersonName v-else :person="item.createdByPerson" />
        <br />
        {{ $dayjs.date(item.createdAt) }}
      </td>
      <slot name="actions-desktop" />
    </template>
    <template v-else>
      <td>
        <div class="mb-2">
          <b>{{ $t("horses:vaccinations.date.label", "Date") }}</b
          ><br />
          {{ $dayjs.date(item.vaccinationDate) }}
        </div>
        <div class="mb-2">
          <b>{{ $t("horses:vaccinations.national_rules.label") }}</b>
          <v-tooltip v-if="item.calculatedCourseStage" location="bottom">
            <template #activator="{ props: attrs }">
              <div v-bind="attrs">
                {{
                  $t("horses:vaccination.stage." + item.calculatedCourseStage)
                }}
                <br />
                ({{
                  vaccinationAllowsToCompetePeriodText(
                    "allowsToCompeteNationallyUntil"
                  )
                }})
              </div>
            </template>
            <span>
              {{
                $t(
                  "horses:vaccinations.ExplanatoryTextforStageCalculation.text",
                  "Automatically calculated based on the preceeding vaccination date. Note that calculations will be corrected after all vaccinations entered"
                )
              }}
            </span>
          </v-tooltip>
          <v-tooltip
            v-if="
              item.courseStage &&
              item.calculatedCourseStage != item.courseStage &&
              item.isOfficial
            "
            location="bottom"
          >
            <template #activator="{ props: attrs }">
              <div v-bind="attrs">
                {{ $t("horses:vaccination.stage." + item.courseStage) }}
                {{
                  $t(
                    "horses:vaccinations.HeppaSourceReference.label",
                    "(HEPPA)"
                  )
                }}
              </div>
            </template>
            <span>
              {{
                $t(
                  "horses:vaccinations.TooltipHeppaData.label",
                  "Data submitted by veterinarian to Hippos register"
                )
              }}
            </span>
          </v-tooltip>
        </div>
        <div class="mb-2">
          <b>{{ $t("horses:vaccinations.international_rules.label") }}</b>
          <v-tooltip v-if="item.calculatedCourseStageFei" location="bottom">
            <template #activator="{ props: attrs }">
              <div v-bind="attrs">
                {{
                  $t(
                    "horses:vaccination.stage." + item.calculatedCourseStageFei
                  )
                }}
                <br />
                ({{
                  vaccinationAllowsToCompetePeriodText(
                    "allowsToCompeteInternationallyUntil"
                  )
                }})
              </div>
            </template>
            <span>
              {{
                $t(
                  "horses:vaccinations.ExplanatoryTextforStageCalculation.text",
                  "Automatically calculated based on the preceeding vaccination date. Note that calculations will be corrected after all vaccinations entered"
                )
              }}
            </span>
          </v-tooltip>
          <v-tooltip
            v-if="
              item.courseStage &&
              item.calculatedCourseStageFei != item.courseStage &&
              item.isOfficial
            "
            location="bottom"
          >
            <template #activator="{ props: attrs }">
              <div v-bind="attrs">
                {{ $t("horses:vaccination.stage." + item.courseStage) }}
                {{
                  $t(
                    "horses:vaccinations.HeppaSourceReference.label",
                    "(HEPPA)"
                  )
                }}
              </div>
            </template>
            <span>
              {{
                $t(
                  "horses:vaccinations.TooltipHeppaData.label",
                  "Data submitted by veterinarian to Hippos register"
                )
              }}
            </span>
          </v-tooltip>
        </div>
        <div class="mb-2">
          <b>{{ $t("horses:vaccinations.comment.label", "Comment") }}</b>
          <br />
          {{ item.comment }}
        </div>

        <div class="mb-2">
          <div>
            <b>{{
              $t("horses:vaccinations.veterinarian.label", "Veterinarian")
            }}</b>
          </div>
          {{ item.veterinarianName }}
        </div>

        <div class="mb-2">
          <div>
            <b>{{ $t("horses:vaccinations.source.label", "Source") }}</b>
          </div>
          <template v-if="item.isOfficial">
            {{ $t("horses:vaccinations.sourceOfficial", "Official") }}
          </template>
          <AppShowPersonName v-else :person="item.createdByPerson" />
          <br />
          {{ $dayjs.date(item.createdAt) }}
        </div>
      </td>
      <td style="white-space: nowrap">
        <slot name="actions-mobile" />
      </td>
    </template>
  </tr>
</template>
<script>
import { defineComponent, toRefs } from "vue";
import { useTranslation } from "i18next-vue";
import gql from "fraql";
import AppShowPersonName from "@AppShows/person/AppShowPersonName.vue";
import { useHorseVaccinationHelper } from "@composables/horse_vaccination_status";
import dayjs from "@/plugins/dayjs";

export default defineComponent({
  name: "AppHorseVaccinationRow",
  components: {
    AppShowPersonName
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    recentValidCheck: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { vaccinationStatusOnDate } = useHorseVaccinationHelper();
    const { t } = useTranslation();
    const { item } = toRefs(props);

    function icon({ returnType, stageType, rule }) {
      if (!item.value) return;

      const stage = item.value[stageType];
      let val = "";

      if (props.recentValidCheck) {
        if (
          ["", "invalid", null].includes(
            vaccinationStatusOnDate(item.value, null, rule)
          )
        ) {
          if (returnType == "color") {
            return "fa fa-light fa-exclamation text-red";
          } else return;
        }
      }

      switch (stage) {
        case "primary_first":
          if (returnType == "color") {
            val = "text-red";
          } else {
            val = "1";
          }
          break;
        case "primary_second":
          if (returnType == "color") {
            val = "text-green";
          } else {
            val = "2";
          }
          break;
        case "first_booster":
          if (returnType == "color") {
            val = "text-green";
          } else {
            val = "3";
          }
          break;
        case "subsequent_booster":
          if (returnType == "color") {
            val = "fa fa-light fa-check text-green";
          }
          break;
      }
      return val;
    }

    function vaccinationAllowsToCompetePeriodText(type) {
      switch (type) {
        case "allowsToCompeteNationallyUntil": {
          if (
            !item.value.allowsToCompeteNationallyUntil ||
            !item.value.allowsToStartCompetingNationallyFrom
          ) {
            return t(
              "horses:vaccinations.NotAllowedToCompete.label",
              "Not allowed to compete"
            );
          }
          let txt = dayjs.date(item.value.allowsToStartCompetingNationallyFrom);
          txt += ` - ${dayjs.date(item.value.allowsToCompeteNationallyUntil)}`;
          txt +=
            " " +
            t("horses:vaccinations.ByNationalRule.label", "by national rule");

          return txt;
        }
        case "allowsToCompeteInternationallyUntil": {
          if (
            !item.value.allowsToCompeteInternationallyUntil ||
            !item.value.allowsToStartCompetingInternationallyFrom
          ) {
            return t(
              "horses:vaccinations.NotAllowedToCompete.label",
              "Not allowed to compete"
            );
          }

          let txt = dayjs.date(
            item.value.allowsToStartCompetingInternationallyFrom
          );
          txt += ` - ${dayjs.date(
            item.value.allowsToCompeteInternationallyUntil
          )}`;
          txt +=
            " " +
            t(
              "horses:vaccinations.ByInternationalRule.label",
              "by international rule"
            );

          return txt;
        }
        default:
          return t(
            "horses:vaccinations.NotAllowedToCompete.label",
            "Not allowed to compete"
          );
      }
    }

    return {
      icon,
      vaccinationAllowsToCompetePeriodText
    };
  },
  fragments: {
    vaccination: gql`
      fragment _ on Vaccination {
        id
        comment
        courseStage
        calculatedCourseStage
        calculatedCourseStageFei
        veterinarianName
        isOfficial
        vaccinationDate
        allowsToCompeteNationallyUntil
        allowsToCompeteInternationallyUntil
        allowsToStartCompetingNationallyFrom
        allowsToStartCompetingInternationallyFrom
        createdByPerson {
          ${AppShowPersonName.fragments.person}
        }
        createdAt
      }
    `
  }
});
</script>
<style scoped>
.fa {
  font-size: x-large;
}
</style>
